import { useState } from "react";
import { ChevronDown, CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";

const HUMANIZE = {
  search_employee: "Searching employees",
  get_employee: "Loading employee profile",
  employee_directory: "Loading employee directory",
  attendance_today: "Checking today's attendance",
  attendance_summary: "Building attendance summary",
  late_arrivals: "Finding late arrivals",
  leave_balance: "Checking leave balance",
  leave_history: "Loading leave history",
  apply_leave: "Submitting leave request",
  cancel_leave: "Cancelling leave",
  payroll_summary: "Pulling payroll summary",
  salary_breakdown: "Loading salary breakdown",
  payslip_link: "Preparing payslip link",
  tax_summary: "Computing tax summary",
  payroll_trend: "Computing payroll trend",
  department_stats: "Counting departments",
  attendance_analytics: "Analysing attendance",
  holiday_calendar: "Loading holiday calendar",
  notifications_unread: "Checking notifications",
  search_policy: "Searching company policies",
};

export default function ToolExecutionCard({ tool }) {
  const [open, setOpen] = useState(false);
  const status = tool.status || "running";
  const label = HUMANIZE[tool.name] || `Running ${tool.name}`;

  const Icon =
    status === "ok" ? CheckCircle2 :
    status === "error" ? AlertTriangle : Loader2;

  const color = status === "ok" ? "ai-tool-ok" : status === "error" ? "ai-tool-err" : "ai-tool-run";

  return (
    <div className={`ai-tool-card ${color}`}>
      <button type="button" className="ai-tool-head" onClick={() => setOpen((v) => !v)}>
        <Icon size={14} className={status === "running" ? "ai-spin" : ""} />
        <span className="ai-tool-label">{label}</span>
        {tool.latencyMs ? <span className="ai-tool-latency">{tool.latencyMs}ms</span> : null}
        <ChevronDown size={13} className={`ai-tool-chev ${open ? "is-open" : ""}`} />
      </button>
      {open ? (
        <div className="ai-tool-body">
          {tool.arguments && Object.keys(tool.arguments).length > 0 ? (
            <pre className="ai-tool-args">{JSON.stringify(tool.arguments, null, 2)}</pre>
          ) : null}
          {tool.error ? <div className="ai-tool-error">{tool.error}</div> : null}
          {tool.preview ? <pre className="ai-tool-preview">{tool.preview}</pre> : null}
        </div>
      ) : null}
    </div>
  );
}
